import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DatepickerUtils {
  private translate = inject(TranslateService);

  getDatepickerLocale() {
    return this.translate
      .stream([
        'datepicker.format',
        'datepicker.displayFormat',
        'datepicker.direction',
        'datepicker.weekLabel',
        'datepicker.separator',
        'datepicker.cancelLabel',
        'datepicker.applyLabel',
        'datepicker.clearLabel',
        'datepicker.customRangeLabel',
        'datepicker.daysOfWeek',
        'datepicker.monthNames',
      ])
      .pipe(
        map((translations) => ({
          format: translations['datepicker.format'],
          displayFormat: translations['datepicker.displayFormat'],
          direction: translations['datepicker.direction'],
          weekLabel: translations['datepicker.weekLabel'],
          separator: translations['datepicker.separator'],
          cancelLabel: translations['datepicker.cancelLabel'],
          applyLabel: translations['datepicker.applyLabel'],
          clearLabel: translations['datepicker.clearLabel'],
          customRangeLabel: translations['datepicker.customRangeLabel'],
          daysOfWeek: translations['datepicker.daysOfWeek'],
          monthNames: translations['datepicker.monthNames'],
          firstDay: 1,
        })),
      );
  }
}
